import { useAuth0 } from '@auth0/auth0-react';
import { TokenCustomClaimKeysEnum } from './SitecoreUser';

export const useUserInOrganization = () => {
  const { isAuthenticated, user } = useAuth0();

  return isAuthenticated && (user?.[TokenCustomClaimKeysEnum.TENANT_ID] || user?.[TokenCustomClaimKeysEnum.ORG_ID]);
};
